/**
 * @generated SignedSource<<a24232564d8077141b9de6eba76ad1ab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserProfilePreviewRelayContent_user$data = {
  readonly singleUser: {
    readonly __typename: "KnowledgeDiscoverySingleUser";
    readonly user: {
      readonly department: string | null;
      readonly email: string | null;
      readonly id: string | null;
      readonly jobTitle: string | null;
      readonly location: string | null;
      readonly name: string | null;
      readonly organization: string | null;
      readonly picture: string | null;
      readonly thirdPartyIntegrations: ReadonlyArray<{
        readonly externalId: string;
        readonly integrationId: string;
        readonly product: string;
      }> | null;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly " $fragmentType": "UserProfilePreviewRelayContent_user";
};
export type UserProfilePreviewRelayContent_user$key = {
  readonly " $data"?: UserProfilePreviewRelayContent_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProfilePreviewRelayContent_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "accountId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "requestingUserId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    }
  ],
  "kind": "Fragment",
  "name": "UserProfilePreviewRelayContent_user",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "accountId",
          "variableName": "accountId"
        },
        {
          "kind": "Variable",
          "name": "requestingUserId",
          "variableName": "requestingUserId"
        },
        {
          "kind": "Variable",
          "name": "tenantId",
          "variableName": "tenantId"
        }
      ],
      "kind": "LinkedField",
      "name": "singleUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "KnowledgeDiscoveryUserProfile",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "id"
                },
                {
                  "kind": "ScalarField",
                  "name": "name"
                },
                {
                  "kind": "ScalarField",
                  "name": "picture"
                },
                {
                  "kind": "ScalarField",
                  "name": "email"
                },
                {
                  "kind": "ScalarField",
                  "name": "jobTitle"
                },
                {
                  "kind": "ScalarField",
                  "name": "department"
                },
                {
                  "kind": "ScalarField",
                  "name": "location"
                },
                {
                  "kind": "ScalarField",
                  "name": "organization"
                },
                {
                  "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                  "kind": "LinkedField",
                  "name": "thirdPartyIntegrations",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "externalId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "integrationId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "product"
                    }
                  ]
                }
              ]
            }
          ],
          "type": "KnowledgeDiscoverySingleUser"
        }
      ]
    }
  ],
  "type": "KnowledgeDiscoveryQueryApi"
};

(node as any).hash = "494ff37156699f69a033081e22ed6e73";

export default node;
